import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextSectionHeaderProps = Pick<
  TypographyProps,
  'label' | 'color' | 'ellipsis' | 'uppercase'
>;

export const TextSectionHeader = ({
  label,
  color = 'text-ds-natural',
  uppercase,
  ellipsis,
}: TextSectionHeaderProps) => (
  <Typography
    uppercase={uppercase}
    color={color}
    label={label}
    ellipsis={ellipsis}
    tagName="h2"
    fontSize="text-ds-700"
    lineHeight="leading-ds-600"
    fontWeight="font-ds-medium"
  />
);
